export default "__VITE_ASSET__DTRW$E_t__"